import React from 'react';

export const useIsSSR = () => {
  const [isSSR, setIsSSR] = React.useState(true);

  React.useEffect(() => {
    setIsSSR(false);
  }, []);

  return isSSR;
};
